import type { HTMLAttributes, Ref } from "react";
import { cn } from "@/lib/utils";
import {
  SCROLL_CONTAINER_PRIORITY,
  useScrollContainerRegistration,
} from "@/contexts/ScrollContainerContext";

type ScrollContainerProps = HTMLAttributes<HTMLDivElement> & {
  isActive?: boolean;
  priority?: number;
  ref?: Ref<HTMLDivElement>;
};

export function ScrollContainer({
  isActive = false,
  priority = SCROLL_CONTAINER_PRIORITY.TAB,
  className,
  children,
  ref,
  ...rest
}: ScrollContainerProps) {
  const setScrollContainerRef = useScrollContainerRegistration(isActive, priority);

  // Merge the caller's ref (React 19 ref-as-prop) with the registration ref so
  // pages keeping their own scroll handle (chat logs) can still register.
  const mergedRef = (element: HTMLDivElement | null) => {
    setScrollContainerRef(element);
    if (typeof ref === "function") ref(element);
    else if (ref) ref.current = element;
  };

  return (
    <div ref={mergedRef} className={cn("h-full min-h-0", className)} {...rest}>
      {children}
    </div>
  );
}

export default ScrollContainer;
